const KEditor = require("./dist/js/keditor");

export { KEditor };